import {URL_PATIENT_PGSEC, URL_PATIENT_PGSEC_SHOW} from "../../../routes/routes-constants";
import { Tables } from "features/common/pgd-pg-common/Table";

export const Table = () => {
  return <Tables pgType="pgsec" urlPatient={URL_PATIENT_PGSEC} urlShowPatient={URL_PATIENT_PGSEC_SHOW}/>
}